import { CALL_API } from '../middleware/api';

export const CHANGE_STEP = 'CHANGE_STEP';
export const SAVE_REQUEST = 'SAVE_REQUEST';
export const SAVE_SUCCESS = 'SAVE_SUCCESS';
export const SAVE_ERROR = 'SAVE_ERROR';


// LIVE //          url: '/save.php',
// LOCAL DEV //     url: 'http://p40web/save.php',
export function saveAntrag(data) {
    return {
        [CALL_API]: {
            reqType: 'POST',
            postData: data,
            url: '/save.php',
            types: [SAVE_REQUEST, SAVE_SUCCESS, SAVE_ERROR]
        }
    };
}

export function changeStep(step) {
    return {
        type: CHANGE_STEP,
        step: step
    };
}


// WEBPACK FOOTER //
// ./src/actions/antragActions.js